const gameScheduleSkeletonStyles = {
    outerContainer: `grid grid-cols-1 gap-2
                     md:grid-cols-3
                     screen-540:grid-cols-2`,
    skeleton: `min-h-[100px] bg-themeShadowColor md:max-w-[500px] rounded-[7px] animate-pulse`
}

export { gameScheduleSkeletonStyles }